import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getOrgById } from '../../../redux/selectors/userData';
import {
  setPoiCodePreference,
  setPoiCreateMinimumRole
} from '../../../redux/slice/poiAdmin/poiAdmin';
import PoiPreferencesForm from './PoiPreferencesForm';

interface ComponentProps {
  organisationId: string;
}

const PoiPreferencesContainer = ({ organisationId }: ComponentProps) => {
  const dispatch = useDispatch();
  const orgData = useSelector(getOrgById(organisationId));

  useEffect(() => {
    if (!orgData || !orgData.org) {
      return;
    }
    dispatch(setPoiCodePreference(orgData.org.poiCodePreference));
    dispatch(setPoiCreateMinimumRole(orgData.org.poiCreateMinimumRole));
  }, [orgData, dispatch]);

  if (!orgData || !orgData.org) {
    return <></>;
  }

  return (
    <div className="px-5 py-3" style={{ height: '100%' }}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          gap: '2em',
          alignItems: 'left',
          width: '100%',
          flexDirection: 'column'
        }}
      >
        <PoiPreferencesForm organisationId={organisationId} />
      </div>
    </div>
  );
};

export default PoiPreferencesContainer;
